import * as types from '../actionTypes';
import PrivateAPIResource from "../../services/PrivateAPIResource";

export function loadGalleriesSuccess(galleries) {
    return {type: types.LOAD_GALLERIES_SUCCESS, galleries};
}

export function createGallerySuccess(gallery) {
    return {type: types.CREATE_GALLERY_SUCCESS, gallery};
}

export function updateGallerySuccess(gallery) {
    return {type: types.UPDATE_GALLERY_SUCCESS, gallery};
}

export function deleteGallerySuccess(id) {
    return {type: types.DELETE_GALLERY_SUCCESS, id};
}

export function getGallerySuccess(gallery) {
    return {type: types.GET_GALLERY_SUCCESS, gallery};
}

export function resetGallery() {
    return { type: types.RESET_GALLERY };
}

export function loadGalleries(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.get('galleries?page='+page, null, sortParams)
            .then(galleries => {
                dispatch(loadGalleriesSuccess(galleries));
            }).catch(error => {
                throw error;
            });
    }
}

export function getGallery(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('galleries', id).then(gallery => {
            dispatch(getGallerySuccess(gallery))
        }).catch(error => {
            throw error;
        });
    }
}

export function deleteGallery(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('galleries', id).then(gallery => {
            dispatch(deleteGallerySuccess(id));
        }).catch(error => {
            throw error;
        });
    }
}

export function saveGallery(gallery) {
    return function (dispatch, getState) {
        return PrivateAPIResource.create('galleries', gallery, false).then(gallery => {
            dispatch(createGallerySuccess(gallery));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateGallery(gallery, id) {
    return function (dispatch, getState) {
        return PrivateAPIResource.update('galleries', id, gallery, false).then(gallery => {
            dispatch(updateGallerySuccess(gallery));
        }).catch(error => {
            throw error;
        })
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/gallery/galleryActions.js